import styled from 'styled-components';

export const ImageContainer = styled.main`
  min-height: 100vh;
  height: 100%;
  width: 80%;
  margin: 0 auto;
  padding-top: ${({ theme }) => theme.spacing.l};
  h4 {
    display: none;
  }
  input {
    width: 50%;
  }
`;
